module.exports = __webpack_public_path__ + "static/fahs-28e4b98f69c982e9635dbc88ca4c4cf9.jpg";